<div class="support-card"
     [class.dimmed]="dimmed()"
     [attr.data-testid]="testId() + '-card'">
  <img [src]="icon()"
       [alt]="iconAlt()"
       class="support-card-icon" />
  <h3 class="support-card-title">{{ cardTitle() }}</h3>
  <p class="support-card-text">{{ description() }}</p>
  <button class="support-card-button"
          [class.sending]="isLoading()"
          [class.success]="success()"
          [class.offline]="isOffline()"
          type="button"
          [disabled]="disabled()"
          (click)="onButtonClick($event)"
          [attr.data-testid]="testId() + '-button'"
          [attr.aria-label]="ariaLabel()">
    @if (isLoading()) {
      <svg class="spin-cw"
           width="20"
           height="20"
           viewBox="0 0 24 24"
           fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M20 20V18H17.25L17.65 17.65C18.5167 16.8833 19.125 16.0083 19.475 15.025C19.825 14.0417 20 13.05 20 12.05C20 10.2 19.446 8.554 18.338 7.112C17.23 5.67 15.784 4.716 14 4.25V6.35C15.2 6.78333 16.1667 7.521 16.9 8.563C17.6333 9.605 18 10.7673 18 12.05C18 12.8 17.8583 13.5293 17.575 14.238C17.2917 14.9467 16.85 15.6007 16.25 16.2L16 16.45V14H14V20H20ZM10 19.75V17.65C8.8 17.2167 7.83333 16.4793 7.1 15.438C6.36667 14.3967 6 13.234 6 11.95C6 11.2 6.14167 10.471 6.425 9.763C6.70833 9.055 7.15 8.40067 7.75 7.8L8 7.55V10H10V4H4V6H6.75L6.35 6.35C5.53333 7.16667 4.93733 8.05433 4.562 9.013C4.18667 9.97167 3.99933 10.9507 4 11.95C4 13.8 4.554 15.446 5.662 16.888C6.77 18.33 8.216 19.284 10 19.75Z"
              fill="#9CA3AF" />
      </svg>
    }
    {{ displayLabel() }}
  </button>
  @if (customTemplate()) {
    <ng-container [ngTemplateOutlet]="customTemplate()!"></ng-container>
  }
</div>